import { getIn } from 'seamless-immutable';
import { ApolloLink } from '@apollo/client';
import query from '@catalogo/core-queries/skin.graphql';

export default cache =>
  new ApolloLink((operation, forward) =>
    forward(operation).map(data => {
      const skin = getIn(data, ['data', 'page', 'components', 'skin-event']);

      if (skin) {
        const path = getIn(operation, ['variables', 'path']);
        cache.writeQuery({
          query,
          data: {
            skin: {
              type: skin.type || '',
              bgColor: skin.bgColor || '',
              priceColor: skin.priceColor || '',
              siteSection: skin.siteSection || '',
              textLight: skin.textLight,
            },
          },
          variables: {
            path,
          },
        });
      }

      return data;
    })
  );
